{
  "promotion": {
    "bookingConfirmation": {
      "title": "Trip booked. Thank you!",
      "content": "<p>We’ve sent the confirmation and separate e-ticket to <b>{email}</b>.</p><p>Haven't arrived within 24 hours? Please contact our customer service.</p><p>You can now view and manage your trip and explore hotel or car rental options on this page.</p>",
      "buttonText": "How did booking go?"
    },
    "checkedInBaggage": {
      "genericBaggageType": "Baggage",
      "numberedBaggageTitle": "{bagNumber}. {baggageType}",
      "baggageWeight": "{weight} kg"
    }
  },
  "subHeader": {
    "backToMyBookings": "Exit trip",
    "backToMyBookingsAria": "Exit trip"
  },
  "includedProducts": {
    "seatWifi": {
      "text": "{displayName}"
    },
    "seatFreshMeal": {
      "text": "{displayName}"
    },
    "seatHotPreOrderMeal": {
      "text": "{displayName}"
    },
    "seatCabinBaggage": {
      "text": "{displayName}"
    },
    "seatPriorityServices": {
      "text": "{displayName}"
    },
    "loungePriority": {
      "title": "Lounge + Priority combo"
    },
    "loungePriorityServices": {
      "text": "{displayName}"
    },
    "loungeCabinBaggage": {
      "title": "Lounge + Carry-on combo",
      "text": "{displayName}"
    },
    "loungeWifi": {
      "title": "Lounge + Internet combo",
      "text": "{displayName}"
    },
    "wifiMeal": {
      "title": "Internet + Meal combo"
    },
    "wifiFreshMeal": {
      "text": "{displayName}"
    },
    "wifiHotPreOrderMeal": {
      "text": "{displayName}"
    }
  },
  "services": {
    "seatWifi": {
      "paid": "{amount} x Seat + Internet"
    },
    "seatMeal": {
      "paid": "{amount} x Seat + Meal"
    },
    "seatPriority": {
      "paid": "{amount} x Seat + Priority"
    },
    "seatCabinBaggage": {
      "paid": "{amount} x Seat + Carry-on"
    },
    "loungePriority": {
      "paid": "{amount} x Lounge + Priority"
    },
    "loungeWifi": {
      "paid": "{amount} x Lounge + Internet"
    },
    "loungeCabinBaggage": {
      "paid": "{amount} x Lounge + Carry-on"
    },
    "wifiMeal": {
      "paid": "{amount} x Internet + Meal"
    }
  },
  "voluntaryChange": {
    "phases": {
      "checkPrices": {
        "loaderText": "Just a moment, we are fetching your options",
        "disclaimer": {
          "title": "The prices reflect the fare difference.",
          "description": "This applies if there are no seats available in your original booking class, if the route changes, or if ticket pricing conditions are no longer met."
        },
        "flexTicketDisclaimer": {
          "title": "Since you have a Flex ticket, ",
          "description": "if your new flight’s price is lower than the original, we will refund the difference."
        },
        "selectNewDates": {
          "plural": "Select the new dates for your flights",
          "singular": "Select the new date for your flight"
        }
      }
    },
    "ticketSelection": {
      "keepOriginalFlight": "Keep your original flight",
      "noChanges": "No changes",
      "priceDisclaimer": "Prices may vary based on availability, and our customer service can only offer the same ones shown here.",
      "flightsNotChangedModal": {
        "title": "Flights not changed",
        "returnToFlightSelect": "Back to flight options",
        "returnToBooking": "Go to Manage booking"
      }
    },
    "changeFlightsModal": {
      "title": "Change your flights"
    }
  },
  "modifyYourTrip": {
    "changeOfPlans": {
      "ticketTypeEligibility": {
        "singular": "You can change the flight with the {ticketType} ticket. Pay only for the fare difference, if any.",
        "plural": "You can change the flights with {ticketTypes} tickets. Pay only for the fare difference, if any.",
        "partial": "You can change some of the flights with your {ticketTypes} tickets. Pay only for the fare difference, if any."
      },
      "ticketEligibility": {
        "singular": "Your ticket type allows you to change your flights. Pay only the fare difference, if any.",
        "plural": "Your ticket types allow you to change your flights. Pay only the fare difference, if any.",
        "partial": "Your ticket types allow you to change some of your flights. Pay only the fare difference, if any."
      },
      "message": {
        "pet": "<strong>As you're travelling with a pet</strong>, changes need to go through an agent. Start a chat with Sisu AI assistant to connect with one, free of charge.",
        "specialAssistance": "<strong>As you booked special assistance</strong>, changes need to go through an agent. Start a chat with Sisu AI assistant to connect with one, free of charge.",
        "awardFlights": "<strong>As you have award flights</strong>, changes need to go through an agent. Start a chat with Sisu AI assistant to connect with one, free of charge.",
        "differentTravelClasses": "<strong>As you have different travel classes</strong>, changes need to go through an agent. Start a chat with Sisu AI assistant to connect with one, free of charge.",
        "genericChat": "<strong>Sisu AI assistant will connect you with an agent</strong> to help you change your flight, free of charge."
      },
      "notification": {
        "checkInClosed": "You can’t make changes anymore because check-in has closed.",
        "ticketTypeNotChangeable": {
          "singular": "{ticketType} ticket doesn't include flight changes.",
          "plural": "{ticketTypes} tickets don't include flight changes."
        },
        "ticketNotChangeable": {
          "singular": "Your ticket type doesn't include flight changes.",
          "plural": "Your ticket types don't include flight changes."
        },
        "unpaidItems": "To change your flights, <strong>remove the unpaid items from your cart or complete the payment.</strong>",
        "tourOperator": "Contact your travel agency or tour operator to change your flights.",
        "alreadyDeparted": "You can’t change this flight because it has already departed.",
        "idTickets": "Please go to MyIDTravel to make changes to your booking."
      },
      "cta": {
        "openChat": "Change via chat"
      }
    }
  }
}
